var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[`w-button-mute`, `btn-volume-${_vm.isMute ? 'off' : 'on'}`],on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return (() => _vm.$emit('on-toggle-mute', _vm.isMute)).apply(null, arguments)}}},[_vm._v("\n  Volume "+_vm._s(_vm.isMute ? 'off' : 'on')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }